// extracted by mini-css-extract-plugin
module.exports =  {"option":"option-vFOAS","content":"content-P2T0i","heading":"heading-dYMDt","icon":"icon-fE4hv","label":"label-qI6Vh"};